import { TabsDesignTokens } from "@primeuix/themes/types/tabs"

const index: TabsDesignTokens = {
  tab: {
    borderColor: '{content.border.color}',
    hoverBorderColor: '{content.border.color}',
    color: '{surface.400}',
    hoverColor: '{text.hover.color}',
    activeColor: '{surface.600}',
    padding: '.875rem .75rem',
    gap: '0.5rem'
  },
  activeBar: {
    background: '{surface.600}'
  },
  tablist: {
    background: 'transparent'
  },
  tabpanel: {
    background: 'transparent',
    color: '{content.color}'
  }
}

export { index as default }
